import {createSelector} from '@reduxjs/toolkit';

import {getChannelCategories} from './get_channel_categories';

export const getAllChannelCategoriesByIds = createSelector(
    getChannelCategories,
    (channelCategories) => channelCategories.byId,
);
